import { anchorate } from "anchorate"

export const onRouteUpdate = () => {
  anchorate()
}
